export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1975_20565)">
                <path
                    d="M28.125 11.75H7.875V26.375C7.875 28.8603 9.88972 30.875 12.375 30.875H23.625C26.1103 30.875 28.125 28.8603 28.125 26.375V11.75Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.375 26.375H14.625V20.75C14.625 18.886 16.136 17.375 18 17.375C19.864 17.375 21.375 18.886 21.375 20.75V26.375Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="18" cy="21.875" r="1.125" fill="black" />
                <path d="M21.375 24.125H28.125" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.875 24.125H14.625" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M28.125 11.75H7.875C7.875 9.88604 9.38604 8.375 11.25 8.375H24.75C26.614 8.375 28.125 9.88604 28.125 11.75Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.375 8.375H14.625C14.625 7.13236 15.6324 6.125 16.875 6.125H19.125C20.3676 6.125 21.375 7.13236 21.375 8.375Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28.125 20.75L28.125 14C29.3676 14 30.375 15.0074 30.375 16.25L30.375 18.5C30.375 19.7426 29.3676 20.75 28.125 20.75Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.875 20.75L7.875 14C6.63236 14 5.625 15.0074 5.625 16.25L5.625 18.5C5.625 19.7426 6.63236 20.75 7.875 20.75Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1975_20565">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
